import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Disclaimer = (props) => {
    return React.createElement(Wrapper, null, props.children);
};
const Wrapper = styled.p `
  background: #fff6da;
  padding: 10px 15px;
  border-radius: 3px;
  color: #333;
  text-align: center;
  border: 1px solid ${THEME.WARNING};
  font-size: 0.8em;
`;
export default Disclaimer;
//# sourceMappingURL=Disclaimer.js.map